<template>
  <div class="full-wrapper">
    <div style="margin:auto;max-width:900px;">
      <h1 style="text-align:left;margin:2rem;color:#1115;">SET I</h1>
      <p style="margin:1rem;line-height:2rem; display:flex;flex-flow:wrap;justify-content:center;">
        <b v-if="address && remaining[8] > 0" @click="callMint(valueI, 'I')"  class="button3" > 
          MINT {{ valueI }} for {{ valueI * 0.25 }} ETH</b>
        
        <input
          v-if="address && remaining[8] > 0"
          style=" margin:auto 1rem;width:128px;height:1rem;"
          v-model="valueI"
          min="1"
          :max="remaining[8]"
          type="range"
        />
        <button v-if="!address" @click="login">Connect Wallet</button>
        <button v-else-if="remaining[8] == 0">Sold Out</button>
      </p>

      <div class="artwrap" style="display:flex;flex-flow:wrap;justify-content:center;">
        <img
          src="~/@/assets/prev/84.jpg"
          style="box-shadow:5px 5px 20px #1111, -5px -5px 20px #ffffff59;width:256px;height:256px;margin:1rem;background:#e1e1e1;border:1px solid #1111;"
          alt=""
        />
        <img
          src="~/@/assets/prev/85.jpg"
          style="box-shadow:5px 5px 20px #1111, -5px -5px 20px #ffffff59;width:256px;height:256px;margin:1rem;background:#e1e1e1;border:1px solid #1111;"
          alt=""
        />
        <img
          src="~/@/assets/prev/86.jpg"
          style="box-shadow:5px 5px 20px #1111, -5px -5px 20px #ffffff59;width:256px;height:256px;margin:1rem;background:#e1e1e1;border:1px solid #1111;"
          alt=""
        />
        <img
          src="~/@/assets/prev/87.jpg"
          style="box-shadow:5px 5px 20px #1111, -5px -5px 20px #ffffff59;width:256px;height:256px;margin:1rem;background:#e1e1e1;border:1px solid #1111;"
          alt=""
        />
        <img
          src="~/@/assets/prev/88.jpg"
          style="box-shadow:5px 5px 20px #1111, -5px -5px 20px #ffffff59;width:256px;height:256px;margin:1rem;background:#e1e1e1;border:1px solid #1111;"
          alt=""
        />
        <img
          src="~/@/assets/prev/89.jpg"
          style="box-shadow:5px 5px 20px #1111, -5px -5px 20px #ffffff59;width:256px;height:256px;margin:1rem;background:#e1e1e1;border:1px solid #1111;"
          alt=""
        />
        <img
          src="~/@/assets/prev/90.jpg"
          style="box-shadow:5px 5px 20px #1111, -5px -5px 20px #ffffff59;width:256px;height:256px;margin:1rem;background:#e1e1e1;border:1px solid #1111;"
          alt=""
        />
        <img
          src="~/@/assets/prev/92.jpg"
          style="box-shadow:5px 5px 20px #1111, -5px -5px 20px #ffffff59;width:256px;height:256px;margin:1rem;background:#e1e1e1;border:1px solid #1111;"
          alt=""
        />
        <img
          src="~/@/assets/prev/93.jpg"
          style="box-shadow:5px 5px 20px #1111, -5px -5px 20px #ffffff59;width:256px;height:256px;margin:1rem;background:#e1e1e1;border:1px solid #1111;"
          alt=""
        />
        <img
          src="~/@/assets/prev/93.jpg"
          style="box-shadow:5px 5px 20px #1111, -5px -5px 20px #ffffff59;width:256px;height:256px;margin:1rem;background:#e1e1e1;border:1px solid #1111;"
          alt=""
        />
        <img
          src="~/@/assets/prev/94.jpg"
          style="box-shadow:5px 5px 20px #1111, -5px -5px 20px #ffffff59;width:256px;height:256px;margin:1rem;background:#e1e1e1;border:1px solid #1111;"
          alt=""
        />
        <img
          src="~/@/assets/prev/I.gif"
          style="box-shadow:5px 5px 20px #1111, -5px -5px 20px #ffffff59;width:256px;height:256px;margin:1rem;background:#e1e1e1;border:1px solid #1111;"
          alt=""
        />
      </div>
      <a style="margin:auto;" href="/#/"
        ><p style="text-align:center;color:#1115;margin-top:2rem;margin-bottom:2rem;">🠔 HOME</p></a
      >
    </div>
  </div>
</template>

<script>
import { ethers } from 'ethers';
import { mapState, mapActions } from 'vuex';
import { shorten } from '@/helpers/utils.ts';

export default {
  data() {
    return {
      valueI: 1,
      form: {
        quantity: ''
      },
      modalLoginOpen: false,
      modalMakepotionOpen: false
    };
  },
  computed: mapState({
    address: state => state.settings.address,
    balance: state => state.settings.balance,
    remaining: state => state.settings.remaining,
    price: state => state.settings.price
  }),
  methods: {
    ...mapActions(['login', 'mint']),
    shorten,
    format(bignum) {
      return parseFloat(ethers.utils.formatEther(bignum)).toFixed(2);
    },
    callMint(quantity_, collection) {
      this.mint({ quantity_, collection });
    }
  },
  components: {}
};
</script>
<style scoped>
.hasEffect {
  cursor: pointer;
}
</style>
